import { EventBus } from 'relapp-event';
import { apiMixin } from 'relapp-api';
import { mapActions, mapGetters } from 'vuex';
import AuthApi from '../services/api/auth.js';

const storesToReset = [
    'resetDns',
    'resetSubscriptions',
    'resetServices',
    'resetServers',
    'resetOrder',
    'resetDomains',
    'resetProducts',
    'resetPageTexts',
    'resetCustomer',
    'resetCustomers',
    'resetUsers',
    'resetNameservers',
    'resetWhois'
];

export default {
    /**
     * Send the logout action to the endpoint, and go to the login page.
     *
     * @param {bool} takenOver
     */
    logoutFromServer({ takenOver }) {
        EventBus.$emit('route', {
            name: 'login'
        });

        AuthApi.logout()
            .then(() => {
                if (takenOver) {
                    window.location = process.env.VUE_APP_NOVA_URI;
                }

                sessionStorage.clear();
                localStorage.clear();
            })
            .catch(error => apiMixin.methods.handleError(error));
    },

    /**
     * Install the plugin.
     *
     * @param {object} Vue
     */
    install(Vue) {
        EventBus.$on('userLoggedOut', this.logoutFromServer);

        Vue.mixin({
            mixins: [apiMixin],
            ...mapGetters({
                currentCustomer: 'user/currentCustomer'
            }),
            methods: {
                ...mapActions({
                    userLogout: 'user/logout',
                    resetSubscriptions: 'subscriptions/reset',
                    resetServices: 'services/reset',
                    resetServers: 'servers/reset',
                    resetDns: 'dns/reset',
                    resetDomains: 'domains/reset',
                    resetProducts: 'products/reset',
                    resetOrder: 'order/reset',
                    resetPageTexts: 'pageTexts/reset',
                    resetCustomer: 'customer/reset',
                    resetCustomers: 'customers/reset',
                    resetUsers: 'users/reset',
                    resetNameservers: 'nameservers/reset',
                    resetWhois: 'whois/reset'
                }),

                /**
                 * Fire an event if you click the logout link.
                 */
                logout() {
                    this.resetStores();
                    this.userLogout();
                },

                /**
                 * Reset stores that are loaded.
                 */
                resetStores() {
                    storesToReset.forEach(store => {
                        if (this[store]) {
                            this[store]();
                        }
                    });
                },

                /**
                 * Reset all stores that are customer specific.
                 *
                 * @param {object} customer
                 */
                switchCustomer(customer) {
                    if (!customer || !this.currentCustomer) {
                        return;
                    }

                    if (this.currentCustomer.id != customer.id) {
                        this.resetStores();
                        if (this.$route.name !== 'services') {
                            this.$router.push({
                                name: 'services',
                                query: {
                                    'customer-id': customer.id
                                }
                            });
                        } else {
                            this.$router.push({
                                query: {
                                    'customer-id': customer.id
                                }
                            });
                        }
                    }
                }
            }
        });
    }
};
